module.exports = __webpack_public_path__ + "static/media/main-weapon.9a2f78de.png";